<template>
     <div class="mine">
      <div class="loading">
          <div class="container">
            <span class="girl"></span>
            <div class="boys">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
      </div>
        <header>
          <h1>个人主页</h1>
        </header>
        <div class="mine-container">
          <div class="head">
            <!-- 头像 -->
            <div class="head_img">
              <img :src="userlist.pic">
            </div>
            <!-- 用户 -->
            <div class="head_cont">
              <p class="cont_p1">{{userlist.nickname}}</p>
              <p class="cont_p2">
              <router-link to="/mine/vip" class="ccccccc">
                <span class="ssssss">立即开通VIP</span>
              </router-link>
              </p>
              <p class="cont_p3">ID:<span>{{userlist.token}}</span></p>
              <p class="cont_p3">{{userlist.at_name}}</p>
            </div>
            <!-- 设置 -->
            <div class="head_set">
              <router-link to="/mine/xingxi">
                <v-icon name="cog" class="set_1"></v-icon>
              </router-link>
              <router-link to="/mine/xiaoxi">
              <v-icon name="comment" class="set_2"></v-icon>             
              </router-link>
            </div>
          </div>
          <!--  -->
          <ul>
          <router-link to="/mine/tixian">
              <li class="nav_1">
                <v-icon name="star" class="tixian1"></v-icon>
                <p class="tixian2">我的余额</p>
                <p class="tixian">{{userlist.user_money}}</p>
              </li>
            </router-link>
              <router-link to="/mine/dingdan">
              <li class="nav_1">
                <v-icon name="clone" class="nava_0"></v-icon>
                全部订单
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
            </router-link>
            <router-link to="/mine/shouzang">
              <li class="nav_2">
                <v-icon name="heart" class="nava_0"></v-icon>
                我的收藏
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
            </router-link>
<!--             <router-link to="/mine/fenxiang">
              <li class="nav_3">
                <v-icon name="share" class="nava_0"></v-icon>
                我的分享
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
            </router-link> -->
            <router-link to="/mine/bofang">
              <li class="nav_4">
                <v-icon name="comment" class="nava_0"></v-icon>
                播放记录
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
             </router-link>
            <router-link to="/mine/liuyan">
              <li class="nav_5">
                <v-icon name="comments" class="nava_0"></v-icon>
                留言记录
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
            </router-link>
            <router-link to="/activity/sign">
              <li class="nav_6">
                <v-icon name="smile" class="nava_0"></v-icon>
                问答解读
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
            </router-link>
            <router-link to="/mine/vip">
              <li class="nav_6">
                <v-icon name="credit-card" class="nava_0"></v-icon>
                开通VIP
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
            </router-link>
            <router-link to="/mine/xingxi">
              <li class="nav_6">
                <v-icon name="cog" class="nava_0"></v-icon>
                个人信息
                <v-icon name="angle-right" class="nava_1"></v-icon>
              </li>
            </router-link>
          </ul>
        </div>
        <div style="height: .6rem;width: 100%;background: #FFFFFF;"></div>
        <div class="appNav">
            <ul>
                <router-link to="/">
                <li class="home">
                    <v-icon name="home" class="hv"></v-icon>
                    <p class="hp">首页</p>
                </li>
                </router-link>
                <router-link to="/discover/all">
                <li class="globe">
                    <v-icon name="globe" class="gv"></v-icon>
                    <p class="gp">专辑</p>
                </li>
                </router-link>
                <router-link to="/activity">
                <li class="comments">
                    <v-icon name="comments" class="cv"></v-icon>
                    <p class="cp">活动</p>
                </li>
                </router-link>
                <router-link to="/mine">
                <li class="user cccc">
                    <v-icon name="user" class="uv"></v-icon>
                    <p class="up">个人</p>
                </li>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
  data() {
    return {
      userlist:[]
    }
  },
  mounted() {
    setTimeout(function(){
      $('.loading').remove()
    },500)
    this.getAjax();
      },
  methods:{
  getAjax:function () {
  var openid=localStorage.getItem("openid");
   var successCallback =  (response) => {
      console.log('success')
      this.userlist = response.data
      if(this.userlist.vip_status == 1){
        var ccc=$("<span>VIP</span>");
        $('.ccccccc').remove()
        $(".cont_p2").append(ccc)
      }
    }
    var errorCallback =  (response) => {
        console.log('error')
    }
    this.$http.get(CURL+'/portal/All/getuser?id='+openid).then(successCallback,errorCallback);
  }
 }
};

</script>

<style lang="scss" scoped>

/*tap*/
.appNav {
  width: 100%;
  height: 0.6rem;
  border-top: 0.01rem solid #f2f2f2;
  background: #ffffff;
  position: fixed;
  bottom:0;
  ul,
  li{
    list-style: none;
  }
  ul{
    li{
        float: left;
        width: 25%;
        text-align: center;
    }
  }
}
.hv,.gv,.cv,.uv{
  margin-top: .13rem;
}
.cccc{
  color: #4eb1d3!important;
}
/*tap*/


/*loading*/
.container {
    margin-top: 50%;
    margin-left:18%; 
    width: 55%;
    height: 1em;
    font-size: 35px;
    display: flex;
    justify-content: space-between;
}

.container span {
    width: 15px;
    height: 15px;
    --duration: 1.5s;
}

.girl {
    animation: slide var(--duration) ease-in-out infinite alternate;
}

@keyframes slide {
    from {
        transform: translateX(0);
        filter: brightness(1);
    }

    to {
        transform: translatex(calc(8em - (1em * 1.25)));
        filter: brightness(1.45);
    }
}

.boys {
    width: 65%;
    display: flex;
    justify-content: space-between;
}

.boys span {
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1) {
    animation-name: jump-off-1;
}

.boys span:nth-child(2) {
    animation-name: jump-off-2;
}

.boys span:nth-child(3) {
    animation-name: jump-off-3;
}

.boys span:nth-child(4) {
    animation-name: jump-off-4;
}

@keyframes jump-off-1 {
    0%, 15% {
        transform: rotate(0deg);
    }

    35%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-2 {
    0%, 30% {
        transform: rotate(0deg);
    }

    50%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-3 {
    0%, 45% {
        transform: rotate(0deg);
    }

    65%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

@keyframes jump-off-4 {
    0%, 60% {
        transform: rotate(0deg);
    }

    80%, 100% {
        transform-origin: -50% center;
        transform: rotate(-180deg);
    }
}

.container span::before {    
    content: '';
    position: absolute;
    width: inherit;
    height: inherit;
    border-radius: 15%;
    box-shadow: 0 0 0.1em rgba(0, 0, 0, 0.3);
}

.girl::before {
    background-color: #7988da;
}

.boys span::before {
    background-color: dodgerblue;
    animation: var(--duration) ease-in-out infinite alternate;
}

.boys span:nth-child(1)::before {
    filter: brightness(1);
    animation-name: jump-down-1;
}

.boys span:nth-child(2)::before {
    filter: brightness(1.15);
    animation-name: jump-down-2;
}

.boys span:nth-child(3)::before {
    filter: brightness(1.3);
    animation-name: jump-down-3;
}

.boys span:nth-child(4)::before {
    filter: brightness(1.45);
    animation-name: jump-down-4;
}

@keyframes jump-down-1 {
    5% {
        transform: scale(1, 1);
    }

    15% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    20%, 25% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    40% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    55%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-2 {
    20% {
        transform: scale(1, 1);
    }

    30% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    35%, 40% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    55% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    70%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-3 {
    35% {
        transform: scale(1, 1);
    }

    45% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    50%, 55% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    70% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    85%, 100% {
        transform: scale(1, 1);
    }
}

@keyframes jump-down-4 {
    50% {
        transform: scale(1, 1);
    }

    60% {
        transform-origin: center bottom;
        transform: scale(1.3, 0.7);
    }

    65%, 70% {
        transform-origin: center bottom;
        transform: scale(0.8, 1.4);
    }

    85% {
        transform-origin: center top;
        transform: scale(1.3, 0.7);
    }

    100%, 100% {
        transform: scale(1, 1);
    }
}

.loading{
  background-color:#00a8d9;
  position:fixed;
  z-index:999999;
  top:0;
  left:0;
  width:100%;
  height:100%;
  text-align:center;
  line-height:300px;
  padding-top: 35%;
  padding-left: 5%;
  padding-right: 5%;
}
/**/
.tixian1{
  float: left;
  margin: 20px 13px 0 12px;
  color: #00a8d9;
  width: 5%;
}
.tixian2{
  float: left;
  width: 20%;
  font-size: 13px;
  line-height: 56px;
  font-weight: 500;

}
.tixiana{
  position: fixed;
  top: 223px;
  width: 100%;
  height: 45.75px;
  text-align: center;
  background-color: #FFFFFF;
  z-index: 999;
  box-shadow: 0 0 10px #97c9d8;
}
.tixian{
  width: 30%;
  font-weight: 500;
  line-height: 56px;
  color: #000;
  float: left;
  margin-left:37px;
}
/**/
header{
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  h1{
    margin-top: .2rem;
    height: 95%;
    line-height: 0px;
    text-align: center;
    font-size: 19px;
    font-weight: 600;
    color: #FFFFFF;
  }
}
.mine {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #eee;
}
.head{
    height: 170px;
    background: #FFFFFF;
}
.mine-container {
  flex: 1;
  float: left;
div{
    .head_img{
      height: 100%;
      width: 40%;
      float: left;
      text-align: center;
      img{
        margin-top: 40px;
        border-radius: 50%;
        width: 90px;
        height: 90px;
      }
    }
    .head_cont{
      height: 100%;
      float: left;
      width: 45%;
      .cont_p1{
        margin-top: 35px;
        font-size: 17px;
        height: 25px;
        line-height: 25px;
        margin-bottom: 2px;
        color: #333;
      }
      .cont_p2{
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        color: red;
        margin-bottom: 2px;
        a{
          color: red;
        }
      }
      .cont_p3{
        height: 25px;
        line-height: 25px;
        color: #333;
      }
    }
    .head_set{
      height: 100%;
      float: left;
      width: 15%;
      i{
        width: 20px;
        height: 20px;
      }
    }
}
  ul{
    li{
      height: 40px;
      margin-bottom: 2px;
      line-height: 40px;
      font-size: 13px;
      font-weight: 500;
      color: #333;
      background-color: #FFFFFF;
      a{
        color: #333;
      }
    }
  }
}
.nava_0{
  float: left;
  margin: 12px 15px 0 15px;
  color: #00a8d9;

}
.nava_1{
  float: right;
  margin-top: 15px;
  margin-right: 15px;
  color: #00a8d9;
}
.set_1{
  margin-top: 9px;
  margin-right: 5px;
}
.set_2{
  margin-top: 9px;
  margin-left: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/mine/index.vue